/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/EventMapAPI',
	'../../../visualizations/vipr/VIPRUtils'
], function(APIFactory, EventMapAPI, VIPRUtils) {

	class EventMap  {
		constructor() {
			this.eventMapList = [];
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [EventMapAPI]);
			}
			return this._api;
		}

		registerEvents(eventMapList){
			this.eventMapList = this.eventMapList.concat(eventMapList);
		}

		initialize() {
		}

		getEventMapList(){

			const partition = VIPRUtils.partition(this.eventMapList, (eventMapEntry) => !!eventMapEntry.override );
			let overrideList = partition.matchList;
			let mergedList = partition.nonMatchList;
			overrideList.forEach( (entry) => {
				const index = mergedList.findIndex((el) => el.gesture === entry.gesture);
				if (index != -1 ){
					//the event map needs to be overridden found
					if (entry.callback){
						//if callback defined, replace the original one
						mergedList[index] = entry;
					}else{
						//if callback is not defined, remove the original one
						mergedList.splice(index, 1);
					}

				}else{
					mergedList.push(entry);
				}

			});

			return mergedList;
		}



	}
	return EventMap;
});
